import React, { useState } from 'react';
import { NavLink, useNavigate, useLocation as useRouterLocation } from 'react-router-dom';
import {
  FaChartBar, FaCalendarAlt, FaQrcode, FaUser, FaUsers,
  FaChartLine, FaBullhorn, FaSignOutAlt, FaBars,
  FaTimes, FaUtensils, FaMapMarkerAlt, FaChevronDown,
  FaTh, FaEllipsisH, FaStar, FaStore, FaClock, FaBell, FaShoppingCart, FaBuilding, FaBoxOpen, FaTruck, FaRoute,
} from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from '../../context/LocationContext';
import { useNotifications } from '../../context/NotificationContext';
import '../../styles/Sidebar.css';


// Tək kafe / filial müdiri üçün tam menyu
const MENU_ITEMS = [
  { path: '/dashboard',    icon: <FaChartBar />,    label: 'Dashboard',      minTier: 1 },
  { path: '/analytics',    icon: <FaChartLine />,   label: 'Hesabatlar',     minTier: 1 },
  { path: '/menu',         icon: <FaUtensils />,    label: 'Menyu',          minTier: 1 },
  { path: '/orders',       icon: <FaShoppingCart />,label: 'Sifarişlər',     minTier: 1 },
  { path: '/floor-plan',   icon: <FaTh />,          label: 'Floor Plan',     minTier: 2 },
  { path: '/bookings',     icon: <FaCalendarAlt />, label: 'Rezervasiyalar', minTier: 2 },
  { path: '/campaigns',    icon: <FaBullhorn />,    label: 'Kampaniyalar',   minTier: 2 },
  { path: '/scanner',      icon: <FaQrcode />,      label: 'QR Skan',        minTier: 2 },
  { path: '/customers',    icon: <FaUsers />,       label: 'Müştərilər',     minTier: 1 },
  { path: '/hours',        icon: <FaClock />,       label: 'İş Saatları',    minTier: 1 },
  { path: '/reviews',      icon: <FaStar />,        label: 'Rəylər',         minTier: 1 },
  { path: '/notifications',     icon: <FaBell />,     label: 'Bildirişlər',  minTier: 1 },
  { path: '/inventory',         icon: <FaBoxOpen />, label: 'Anbar',        minTier: 1 },
  { path: '/delivery-orders',   icon: <FaRoute />,   label: 'Çatdırılma',   minTier: 1 },
  { path: '/couriers',          icon: <FaTruck />,   label: 'Kuryerlər',    minTier: 1 },
  { path: '/corporate-report', icon: <FaBuilding />, label: 'Korporativ',   minTier: 1 },
  { path: '/profile',           icon: <FaUser />,    label: 'Profil',       minTier: 1 },
];

// İdarəedici hesab mode — chain-level, filial-spesifik bölmələr YOX
const ADMIN_ITEMS = [
  { path: '/chain-overview', icon: <FaStore />,        label: 'Filial İcmalı' },
  { path: '/analytics',      icon: <FaChartLine />,    label: 'Hesabatlar' },
  { path: '/menu',           icon: <FaUtensils />,     label: 'Menyu' },
  { path: '/campaigns',      icon: <FaBullhorn />,     label: 'Kampaniyalar' },
  { path: '/locations',      icon: <FaMapMarkerAlt />, label: 'Filiallar' },
  { path: '/profile',        icon: <FaUser />,         label: 'Profil' },
];

// Filial mode — chain owner filial seçəndə tam idarəetmə
const BRANCH_ITEMS = [
  { path: '/dashboard',    icon: <FaChartBar />,    label: 'Dashboard' },
  { path: '/analytics',    icon: <FaChartLine />,   label: 'Hesabatlar' },
  { path: '/menu',         icon: <FaUtensils />,    label: 'Menyu' },
  { path: '/orders',       icon: <FaShoppingCart />,label: 'Sifarişlər' },
  { path: '/floor-plan',   icon: <FaTh />,          label: 'Floor Plan' },
  { path: '/bookings',     icon: <FaCalendarAlt />, label: 'Rezervasiyalar' },
  { path: '/campaigns',    icon: <FaBullhorn />,    label: 'Kampaniyalar' },
  { path: '/scanner',      icon: <FaQrcode />,      label: 'QR Skan' },
  { path: '/customers',    icon: <FaUsers />,       label: 'Müştərilər' },
  { path: '/hours',        icon: <FaClock />,       label: 'İş Saatları' },
  { path: '/reviews',           icon: <FaStar />,     label: 'Rəylər' },
  { path: '/notifications',     icon: <FaBell />,     label: 'Bildirişlər' },
  { path: '/inventory',         icon: <FaBoxOpen />,  label: 'Anbar' },
  { path: '/delivery-orders',   icon: <FaRoute />,    label: 'Çatdırılma' },
  { path: '/couriers',          icon: <FaTruck />,    label: 'Kuryerlər' },
  { path: '/corporate-report',  icon: <FaBuilding />, label: 'Korporativ' },
  { path: '/profile',           icon: <FaUser />,     label: 'Profil' },
];

// Bottom nav — mobile
const BOTTOM_NAV_DEFAULT = [
  { path: '/dashboard',  icon: <FaChartBar />,    label: 'Dashboard' },
  { path: '/bookings',   icon: <FaCalendarAlt />, label: 'Rezerv' },
  { path: '/scanner',    icon: <FaQrcode />,      label: 'QR Skan' },
  { path: '/menu',       icon: <FaUtensils />,    label: 'Menyu' },
  { path: '/profile',    icon: <FaUser />,        label: 'Profil' },
];

const BOTTOM_NAV_ADMIN = [
  { path: '/chain-overview', icon: <FaStore />,     label: 'Filiallar' },
  { path: '/menu',           icon: <FaUtensils />,  label: 'Menyu' },
  { path: '/campaigns',      icon: <FaBullhorn />,  label: 'Kampaniya' },
  { path: '/analytics',      icon: <FaChartLine />, label: 'Hesabat' },
  { path: '/profile',        icon: <FaUser />,      label: 'Profil' },
];

const Sidebar = () => {
  const { business, logout } = useAuth();
  const { locations, activeLocation, setActiveLocation, isOwner, userRole, isAdminView, setAdminView } = useLocation();
  const { unreadCount } = useNotifications();
  const navigate = useNavigate();
  const routerLocation = useRouterLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [locDropdownOpen, setLocDropdownOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);

  const isChainOwner = isOwner && !!business?.is_chain;
  const isAdminMode  = isChainOwner && isAdminView;

  const visibleItems = isChainOwner
    ? (isAdminMode ? ADMIN_ITEMS : BRANCH_ITEMS)
    : MENU_ITEMS.filter(item => item.path !== '/locations');

  const bottomNav = isAdminMode ? BOTTOM_NAV_ADMIN : BOTTOM_NAV_DEFAULT;

  const branchLocs = locations;

  const toggleSidebar = () => setIsOpen(p => !p);
  const closeSidebar  = () => setIsOpen(false);

  return (
    <>
      <button className="hamburger-button" onClick={toggleSidebar}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>

      {isOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}

      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>☕ Cafegoo</h2>
          <p>{business?.name}</p>


          {/* Manager role badge */}
          {!isOwner && (
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 5,
              marginTop: 8, padding: '3px 10px', borderRadius: 20,
              background: 'rgba(255,255,255,0.15)',
              border: '1px solid rgba(255,255,255,0.25)',
              color: '#fff', fontSize: 11, fontWeight: 700, letterSpacing: 0.5,
            }}>
              👤 {userRole === 'manager' ? 'Menecer' : 'Staff'}
            </div>
          )}

          {/* Location switcher — only if owner with multiple locations */}
          {isOwner && locations.length > 0 && (
            <div style={{ marginTop: 10, position: 'relative' }}>
              <div
                onClick={() => setLocDropdownOpen(p => !p)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  padding: '6px 10px', borderRadius: 8,
                  background: 'rgba(255,255,255,0.12)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  cursor: 'pointer', fontSize: 12, fontWeight: 600,
                  color: '#fff',
                }}
              >
                <span style={{ fontSize: 11 }}>
                  {isAdminMode ? '🏢' : '📍'}
                </span>
                <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {isAdminMode ? 'İdarəedici hesab' : (activeLocation?.name || 'Filial seçin')}
                </span>
                <FaChevronDown style={{ fontSize: 9, flexShrink: 0, transform: locDropdownOpen ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
              </div>
              {locDropdownOpen && (
                <div style={{
                  position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 2000,
                  background: '#fff', borderRadius: 8, marginTop: 4,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.18)',
                  overflow: 'hidden', maxHeight: 260, overflowY: 'auto',
                }}>
                  {/* İdarəedici hesab */}
                  <div
                    onClick={() => {
                      setAdminView(true);
                      setLocDropdownOpen(false);
                      navigate('/chain-overview');
                    }}
                    style={{
                      padding: '10px 12px', fontSize: 12, cursor: 'pointer',
                      color: isAdminMode ? '#f97316' : '#1a1a2e',
                      fontWeight: isAdminMode ? 800 : 600,
                      background: isAdminMode ? '#fff7ed' : '#fff',
                      borderBottom: '2px solid #f1f5f9',
                      display: 'flex', alignItems: 'center', gap: 7,
                    }}
                  >
                    <span>🏢</span>
                    <div>
                      <div>İdarəedici hesab</div>
                      <div style={{ fontSize: 10, color: '#aaa', fontWeight: 400 }}>Ümumi idarəetmə</div>
                    </div>
                    {isAdminMode && <span style={{ marginLeft: 'auto', fontSize: 10 }}>✓</span>}
                  </div>
                  {/* Filiallar */}
                  {branchLocs.map(loc => {
                    const active = !isAdminMode && activeLocation?.id === loc.id;
                    return (
                      <div
                        key={loc.id}
                        onClick={() => {
                          setAdminView(false);
                          setActiveLocation(loc);
                          setLocDropdownOpen(false);
                          navigate('/dashboard');
                        }}
                        style={{
                          padding: '9px 12px', fontSize: 12, cursor: 'pointer',
                          color: active ? '#f97316' : '#333',
                          fontWeight: active ? 700 : 400,
                          background: active ? '#fff7ed' : '#fff',
                          borderBottom: '1px solid #f5f5f5',
                          display: 'flex', alignItems: 'center', gap: 7,
                        }}
                      >
                        <span style={{ fontSize: 11 }}>📍</span>
                        <span style={{ flex: 1 }}>{loc.name}</span>
                        {active && <span style={{ fontSize: 10, color: '#f97316' }}>✓</span>}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>

        <nav className="sidebar-menu">
          {visibleItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
                onClick={closeSidebar}
              >
                <span className="menu-icon">{item.icon}</span>
                <span className="menu-label">{item.label}</span>
                {item.path === '/notifications' && unreadCount > 0 && (
                  <span style={{
                    marginLeft: 'auto', background: '#ef4444', color: '#fff',
                    fontSize: 10, fontWeight: 800, borderRadius: 10, padding: '2px 6px',
                    minWidth: 18, textAlign: 'center',
                  }}>
                    {unreadCount > 9 ? '9+' : unreadCount}
                  </span>
                )}
              </NavLink>
            ))}
        </nav>

        <button className="logout-button" onClick={logout}>
          <FaSignOutAlt />
          <span>Çıxış</span>
        </button>
      </div>

      {/* ── Bottom Nav (mobile only) ── */}
      <nav className="bottom-nav">
        {(isChainOwner ? bottomNav : BOTTOM_NAV_DEFAULT).map(item => {
          const isActive = routerLocation.pathname === item.path;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`bn-item${isActive ? ' active' : ''}`}
              onClick={() => { closeSidebar(); setMoreOpen(false); }}
            >
              <span className="bn-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          );
        })}
        <button
          className={`bn-more${moreOpen ? ' open' : ''}`}
          onClick={() => { setMoreOpen(p => !p); closeSidebar(); }}
        >
          <span className="bn-icon"><FaEllipsisH /></span>
          <span>Daha çox</span>
        </button>
      </nav>

      {/* ── "More" drawer (mobile) ── */}
      {moreOpen && (
        <>
          <div className="sidebar-overlay" onClick={() => setMoreOpen(false)} />
          <div className="more-drawer">
            {visibleItems.filter(i => !(isChainOwner ? bottomNav : BOTTOM_NAV_DEFAULT).find(b => b.path === i.path)).map(item => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => `more-item${isActive ? ' active' : ''}`}
                  onClick={() => setMoreOpen(false)}
                >
                  <span className="more-icon">{item.icon}</span>
                  <span className="more-label">{item.label}</span>
                </NavLink>
              ))}
            <button
              className="more-logout"
              onClick={() => { setMoreOpen(false); logout(); }}
            >
              <FaSignOutAlt /> Çıxış
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default Sidebar;
